import { render } from "./AppointmentComponent.vue?vue&type=template&id=3a9fd0c4&scoped=true"
import script from "./AppointmentComponent.vue?vue&type=script&lang=js"
export * from "./AppointmentComponent.vue?vue&type=script&lang=js"

import "./AppointmentComponent.vue?vue&type=style&index=0&id=3a9fd0c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9fd0c4"]])

export default __exports__